











 


















const node = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "DashboardAvatar_teamMember"
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isLead",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PromoteToTeamLeadMutation_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isViewerLead",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamMember",
      "kind": "LinkedField",
      "name": "oldLeader",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamMember",
      "kind": "LinkedField",
      "name": "newLeader",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "PromoteToTeamLeadPayload",
  "abstractKey": null
};
})();

(node ).hash = "3b79c512e80eaab4bf8b91a32f3eb597";

export default node;
